import { SortTypeEnum } from '@/request/request.enum';
import { ComponentPropsWithoutRef, ComponentPropsWithRef, forwardRef } from 'react';
import { Omit } from 'viem';

type theme = 'dark' | 'light' | 'system';

export interface ISvg extends Omit<ComponentPropsWithoutRef<'svg'>, 'type' | 'lightingColor'> {
  children?: JSX.Element | JSX.Element[] | string;
  theme?: theme;
}

export interface IImg extends Omit<ComponentPropsWithoutRef<'img'>, 'src'> {
  theme?: theme;
}

export interface IHighlight extends ISvg {
  highlightColor?: string;
}

export const Copy = forwardRef<SVGSVGElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...attr}>
      <path
        d="M8.00101 2.99951H2.9995C1.34292 2.99951 0 4.34244 0 5.99902V11.0005C0 12.6571 1.34292 14 2.9995 14H8.00101C9.65759 14 11.0005 12.6571 11.0005 11.0005V5.99902C11.0005 4.34244 9.65759 2.99951 8.00101 2.99951Z"
        fill={color}
        fillOpacity="0.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.16504 2.016C3.27471 2.00434 3.38671 1.99967 3.49987 1.99967H8.50021C9.42847 1.99967 10.3187 2.36842 10.9751 3.0248C11.6315 3.68118 12.0002 4.57142 12.0002 5.49967V10.5C12.0002 10.6132 11.9944 10.7252 11.9839 10.8348C12.5728 10.6303 13.0833 10.2474 13.4446 9.7393C13.8059 9.23124 14 8.62326 13.9999 7.99984V2.9995C13.9999 2.20399 13.6839 1.44105 13.1214 0.878534C12.5588 0.316018 11.7959 0 11.0004 0L6.00004 0C4.68754 0 3.57337 0.842335 3.16504 2.016Z"
        fill={color}
        fillOpacity="0.8"
      />
    </svg>
  );
});

export const CopySuccess = (props: ISvg) => {
  const { ...attr } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...attr}>
      <path
        d="M8.00101 2.99951H2.9995C1.34292 2.99951 0 4.34244 0 5.99902V11.0005C0 12.6571 1.34292 14 2.9995 14H8.00101C9.65759 14 11.0005 12.6571 11.0005 11.0005V5.99902C11.0005 4.34244 9.65759 2.99951 8.00101 2.99951Z"
        fill="#0ECB81"
      />
      <path d="M2.08643 8.95L4.36599 11.2296L8.91342 6.67044" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.16504 2.016C3.27471 2.00434 3.38671 1.99967 3.49987 1.99967H8.50021C9.42847 1.99967 10.3187 2.36842 10.9751 3.0248C11.6315 3.68118 12.0002 4.57142 12.0002 5.49967V10.5C12.0002 10.6132 11.9944 10.7252 11.9839 10.8348C12.5728 10.6303 13.0833 10.2474 13.4446 9.7393C13.8059 9.23124 14 8.62326 13.9999 7.99984V2.9995C13.9999 2.20399 13.6839 1.44105 13.1214 0.878534C12.5588 0.316018 11.7959 0 11.0004 0L6.00004 0C4.68754 0 3.57337 0.842335 3.16504 2.016Z"
        fill="#0ECB81"
      />
    </svg>
  );
};

export const CopyError = (props: ISvg) => {
  const { ...attr } = props;
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <g id="Clip path group">
        <g id="Group">
          <g id="Group 567">
            <path
              id="Vector"
              d="M8.00101 2.99951H2.9995C1.34292 2.99951 0 4.34244 0 5.99902V11.0005C0 12.6571 1.34292 14 2.9995 14H8.00101C9.65759 14 11.0005 12.6571 11.0005 11.0005V5.99902C11.0005 4.34244 9.65759 2.99951 8.00101 2.99951Z"
              fill="#F6465D"
            />
            <path
              id="Vector_2"
              d="M8.3305 11.2736L2.72607 5.66922"
              stroke="white"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_3"
              d="M8.27386 5.72589L2.66943 11.3303"
              stroke="white"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_4"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.16504 2.016C3.27471 2.00434 3.38671 1.99967 3.49987 1.99967H8.50021C9.42847 1.99967 10.3187 2.36842 10.9751 3.0248C11.6315 3.68118 12.0002 4.57142 12.0002 5.49967V10.5C12.0002 10.6132 11.9944 10.7252 11.9839 10.8348C12.5728 10.6303 13.0833 10.2474 13.4446 9.7393C13.8059 9.23124 14 8.62326 13.9999 7.99984V2.9995C13.9999 2.20399 13.6839 1.44105 13.1214 0.878534C12.5588 0.316018 11.7959 0 11.0004 0L6.00004 0C4.68754 0 3.57337 0.842335 3.16504 2.016Z"
              fill="#F6465D"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const X = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...attr}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0012207 8.5C0.0012207 12.9183 3.58295 16.5 8.00122 16.5C12.4195 16.5 16.0012 12.9183 16.0012 8.5C16.0012 4.08173 12.4195 0.5 8.00122 0.5C3.58295 0.5 0.0012207 4.08173 0.0012207 8.5ZM12.3246 4.06771H10.8209L8.34296 6.90019L6.20053 4.06771H3.09757L6.80512 8.91579L3.29122 12.932H4.79588L7.5079 9.83313L9.87808 12.932H12.9042L9.03938 7.82253L12.3246 4.06771ZM11.1263 12.0319H10.2931L4.85361 4.9205H5.74777L11.1263 12.0319Z"
        fill={color}
        fillOpacity="0.8"
      />
    </svg>
  );
};

export const Twitter2X = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none" {...attr}>
      <path
        d="M13.6688 1.89697H16.1583L10.7195 8.11313L17.1178 16.5719H12.108L8.18416 11.4417L3.69438 16.5719H1.2034L7.0207 9.92304L0.882812 1.89697H6.01979L9.56661 6.58618L13.6688 1.89697ZM12.7951 15.0818H14.1745L5.27024 3.30878H3.78996L12.7951 15.0818Z"
        fill={color}
        fillOpacity="0.8"
      />
    </svg>
  );
};

export const WebSite = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...attr}>
      <g clipPath="url(#clip0_51_3249)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.0012207 8.5C0.0012207 12.9183 3.58295 16.5 8.00122 16.5C12.4195 16.5 16.0012 12.9183 16.0012 8.5C16.0012 4.08173 12.4195 0.5 8.00122 0.5C3.58295 0.5 0.0012207 4.08173 0.0012207 8.5ZM14.0012 8.49997C14.0012 11.809 11.3225 14.4924 8.01517 14.4999L8.00129 14.5L7.98743 14.4999C4.68465 14.4925 2.00866 11.8164 2.00132 8.5136L2.00122 8.49887L2.00132 8.48365C2.01013 5.17746 4.69302 2.5 8.00127 2.5C11.315 2.5 14.0012 5.18628 14.0012 8.49997ZM7.99543 13.6428C7.9288 13.6411 7.79741 13.6101 7.6036 13.4187C7.40027 13.2178 7.17783 12.8847 6.97255 12.4052C6.80037 12.0031 6.65213 11.5259 6.53815 10.9911C7.00644 11.0414 7.49655 11.0681 8.00122 11.0681C8.50594 11.0681 8.99611 11.0414 9.46444 10.9911C9.35046 11.5259 9.20222 12.0031 9.03004 12.4052C8.82475 12.8847 8.60232 13.2178 8.39898 13.4187C8.20518 13.6101 8.07379 13.6411 8.00716 13.6428L8.00127 13.6428L7.99543 13.6428ZM6.53745 13.4315C4.87375 12.9384 3.56203 11.6264 3.06938 9.96249C3.70807 10.3563 4.59749 10.67 5.63871 10.8612C5.82982 11.9028 6.14353 12.7925 6.53745 13.4315ZM3.08253 8.10118C2.88446 8.3017 2.85844 8.43064 2.85844 8.49997C2.85844 8.56848 2.88655 8.69815 3.08253 8.89656C3.28338 9.09989 3.61655 9.32233 4.09597 9.52761C4.49777 9.69966 4.97457 9.84782 5.5089 9.96176C5.45874 9.49387 5.43211 9.0042 5.43211 8.5C5.43211 7.99497 5.45883 7.50452 5.50914 7.03593C4.97472 7.14988 4.49784 7.29805 4.09597 7.47012C3.61655 7.67541 3.28338 7.89785 3.08253 8.10118ZM6.5375 3.56844C4.87468 4.06125 3.56344 5.37214 3.07017 7.03476C3.7089 6.64107 4.59817 6.32753 5.63914 6.13644C5.8303 5.09583 6.14385 4.20691 6.5375 3.56844ZM10.3639 10.8612C10.1728 11.9028 9.85907 12.7925 9.46515 13.4315C11.1288 12.9383 12.4405 11.6263 12.9332 9.96242C12.2945 10.3563 11.4051 10.67 10.3639 10.8612ZM9.4651 3.56846C11.1279 4.06129 12.4391 5.3722 12.9324 7.03483C12.2937 6.64113 11.4044 6.32757 10.3635 6.13647C10.1723 5.09586 9.85875 4.20693 9.4651 3.56846ZM9.61323 10.1106C9.10781 10.1753 8.5668 10.2109 8.00122 10.2109C7.43569 10.2109 6.89474 10.1753 6.38936 10.1106C6.32478 9.60562 6.28925 9.06507 6.28925 8.5C6.28925 7.93407 6.32489 7.39274 6.38965 6.88705C6.89495 6.8224 7.4358 6.78683 8.00122 6.78683C8.56669 6.78683 9.1076 6.82241 9.61294 6.88707C9.6777 7.39276 9.71334 7.93407 9.71334 8.5C9.71334 9.06507 9.67781 9.6056 9.61323 10.1106ZM10.4934 7.03596C11.0278 7.1499 11.5046 7.29806 11.9065 7.47012C12.3859 7.67541 12.7191 7.89785 12.9199 8.10118C13.1171 8.30085 13.1441 8.43426 13.1441 8.49887C13.1441 8.56348 13.1171 8.69689 12.9199 8.89656C12.7191 9.09989 12.3859 9.32233 11.9065 9.52761C11.5047 9.69965 11.028 9.84779 10.4937 9.96173C10.5438 9.49384 10.5705 9.00418 10.5705 8.5C10.5705 7.99499 10.5438 7.50454 10.4934 7.03596ZM9.46395 6.00658C9.35004 5.4727 9.20197 4.99628 9.03004 4.59475C8.82475 4.11533 8.60232 3.78216 8.39898 3.58131C8.19932 3.38408 8.0659 3.35714 8.00129 3.35714C7.93669 3.35714 7.80327 3.38408 7.6036 3.58131C7.40027 3.78216 7.17784 4.11533 6.97255 4.59475C6.80062 4.99627 6.65255 5.47269 6.53864 6.00656C7.00678 5.95635 7.49673 5.92969 8.00122 5.92969C8.50576 5.92969 8.99576 5.95635 9.46395 6.00658Z"
          fill={color}
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_51_3249">
          <rect x="0.0012207" y="0.5" width="16" height="16" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Browser = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none" {...attr}>
      <g clipPath="url(#clip0_1721_40838)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.00006 0.234375C4.03769 0.234375 0.0133554 4.25056 0.000152141 9.20985L0 9.23271L0.00014231 9.25476C0.0111614 14.209 4.02513 18.223 8.97931 18.2342L9.0001 18.2344L9.00123 18.2344L9.02131 18.2342C13.9821 18.2228 18 14.1978 18 9.23432C18 4.26379 13.9706 0.234375 9.00006 0.234375ZM8.54481 2.13759C8.81424 1.87145 8.96639 1.86119 9.0001 1.86119C9.03381 1.86119 9.18595 1.87145 9.45538 2.13759C9.73186 2.41069 10.0471 2.8775 10.3429 3.56835C10.5635 4.08362 10.7579 4.68746 10.9148 5.36238C10.2978 5.30443 9.65709 5.27391 8.99999 5.27391C8.34297 5.27391 7.70237 5.30442 7.08544 5.36236C7.24225 4.68744 7.43669 4.08361 7.65732 3.56835C7.95314 2.8775 8.26834 2.41069 8.54481 2.13759ZM5.37182 5.60401C4.09293 5.84875 2.96586 6.22016 2.07928 6.68558C2.82432 4.66322 4.43079 3.05719 6.45345 2.31275C5.98807 3.19897 5.61665 4.32559 5.37182 5.60401ZM12.6284 5.60405C12.3836 4.32564 12.0121 3.19901 11.5468 2.31279C13.5694 3.05725 15.1759 4.66329 15.9209 6.68567C15.0343 6.22024 13.9073 5.84881 12.6284 5.60405ZM6.66812 9.23437C6.66812 8.46301 6.7136 7.72348 6.79666 7.02902C7.49053 6.94612 8.22938 6.90073 8.99999 6.90073C9.77068 6.90073 10.5096 6.94612 11.2035 7.02905C11.2866 7.7235 11.3321 8.46302 11.3321 9.23437C11.3321 10.0045 11.2867 10.7428 11.2039 11.4363C10.5099 11.5193 9.77083 11.5647 8.99999 11.5647C8.22923 11.5647 7.49025 11.5193 6.79625 11.4363C6.71345 10.7429 6.66812 10.0045 6.66812 9.23437ZM3.33397 7.88993C3.84974 7.66908 4.45425 7.47448 5.12996 7.31759C5.07189 7.9352 5.04131 8.57656 5.04131 9.23437C5.04131 9.89097 5.07177 10.5312 5.12964 11.1477C4.45406 10.9909 3.84966 10.7963 3.33397 10.5755C2.64312 10.2797 2.17631 9.96447 1.90321 9.68799C1.6378 9.41929 1.62693 9.27257 1.62693 9.23432C1.62693 9.19388 1.63564 9.0483 1.90321 8.77742C2.17631 8.50094 2.64312 8.18575 3.33397 7.88993ZM12.9589 9.23437C12.9589 8.57658 12.9283 7.93524 12.8702 7.31764C13.5459 7.47452 14.1503 7.6691 14.666 7.88993C15.3569 8.18575 15.8237 8.50094 16.0968 8.77742C16.3629 9.04685 16.3732 9.19899 16.3732 9.23271C16.3732 9.26642 16.3629 9.41856 16.0968 9.68799C15.8237 9.96447 15.3569 10.2797 14.666 10.5755C14.1504 10.7963 13.5461 10.9908 12.8706 11.1477C12.9284 10.5311 12.9589 9.89095 12.9589 9.23437ZM11.5468 16.1558C12.0126 15.2688 12.3842 14.141 12.629 12.8612C13.9084 12.6163 15.0357 12.2447 15.9223 11.779C15.178 13.8032 13.5708 15.4109 11.5468 16.1558ZM5.37116 12.8613C4.09184 12.6164 2.96447 12.2448 2.07781 11.7791C2.8222 13.8033 4.42942 15.4109 6.45338 16.1559C5.98762 15.2689 5.61597 14.1411 5.37116 12.8613ZM8.99999 13.1915C9.65737 13.1915 10.2983 13.161 10.9155 13.103C10.7586 13.7793 10.5639 14.3842 10.3429 14.9004C10.0471 15.5912 9.73186 16.058 9.45538 16.3311C9.19757 16.5858 9.04728 16.606 9.006 16.6074L9.00006 16.6074L8.9942 16.6074C8.95292 16.606 8.80263 16.5858 8.54481 16.3311C8.26833 16.058 7.95314 15.5912 7.65732 14.9004C7.43632 14.3843 7.2416 13.7793 7.08465 13.103C7.70182 13.161 8.34269 13.1915 8.99999 13.1915Z"
          fill={color}
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1721_40838">
          <rect width="18" height="18" fill="white" transform="translate(0 0.234375)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Tg = (props: ISvg) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...attr}>
      <g clipPath="url(#clip0_51_3240)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00122 16.5C12.4195 16.5 16.0012 12.9183 16.0012 8.5C16.0012 4.08172 12.4195 0.5 8.00122 0.5C3.58294 0.5 0.0012207 4.08172 0.0012207 8.5C0.0012207 12.9183 3.58294 16.5 8.00122 16.5ZM2.48829 8.26413C5.52648 6.94044 7.55242 6.06778 8.5661 5.64616C11.4604 4.44233 12.0618 4.23322 12.4538 4.22631C12.54 4.22479 12.7327 4.24616 12.8576 4.34748C12.963 4.43303 12.9921 4.5486 13.0059 4.62972C13.0198 4.71083 13.0371 4.89561 13.0234 5.03999C12.8665 6.68793 12.1879 10.6871 11.8426 12.5328C11.6965 13.3138 11.4089 13.5756 11.1304 13.6013C10.6511 13.6454 10.2632 13.3688 9.83137 13.061C9.7179 12.9801 9.60139 12.897 9.47939 12.817C9.00058 12.5032 8.6305 12.2512 8.25947 11.9985L8.25944 11.9985C7.9197 11.7671 7.57915 11.5352 7.15358 11.2547C6.26798 10.6711 6.6387 10.3138 7.13305 9.8372L7.13308 9.83718C7.2131 9.76004 7.29636 9.67978 7.37805 9.59493C7.41452 9.55705 7.59294 9.39118 7.84446 9.15734L7.84447 9.15733L7.84449 9.15731C8.65133 8.4072 10.2104 6.95776 10.2497 6.79002C10.2562 6.76251 10.2622 6.65993 10.2012 6.60577C10.1403 6.5516 10.0504 6.57012 9.98546 6.58485C9.89346 6.60573 8.42813 7.57427 5.58945 9.49045C5.17352 9.77606 4.79678 9.91522 4.45924 9.90793C4.08713 9.89989 3.37133 9.69753 2.8392 9.52455C2.76112 9.49917 2.68496 9.47523 2.61145 9.45211L2.6114 9.45209L2.61125 9.45205C2.07039 9.28198 1.67321 9.15709 1.71297 8.83992C1.7365 8.65225 1.99494 8.46032 2.48829 8.26413Z"
          fill={color}
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_51_3240">
          <rect width="16" height="16" fill="white" transform="translate(0.0012207 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Telegram = (props: ISvg) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none" {...attr}>
      <g clipPath="url(#clip0_1721_40837)">
        <path
          d="M6.86746 16.1018L7.14719 11.7318L14.817 4.58219C15.1573 4.26283 14.7477 4.10772 14.2979 4.38666L4.82998 10.5743L0.734854 9.23173C-0.143393 8.97364 -0.153473 8.3434 0.9352 7.88914L16.8841 1.5242C17.6131 1.18334 18.3124 1.70995 18.0327 2.8668L15.3166 16.1011C15.1264 17.0416 14.5776 17.2684 13.8185 16.835L9.68365 13.674L7.69656 15.667C7.46661 15.9049 7.27697 16.1011 6.86746 16.1011V16.1018Z"
          fill={color}
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1721_40837">
          <rect width="18" height="18" fill="white" transform="translate(0 0.234375)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Star = (props: IHighlight) => {
  const { highlightColor, theme, ...attr } = props;
  const color = highlightColor || (theme == 'light' ? '#18181B33' : '#FAFAFA33');

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...attr}>
      <path
        d="M8.0267 2.28723C8.42468 1.48755 9.57457 1.48755 9.97254 2.28723L11.5106 5.37786C11.6687 5.69542 11.9742 5.91552 12.3276 5.96644L15.7668 6.46205C16.6568 6.59028 17.0121 7.67481 16.3681 8.29727L13.8795 10.703C13.6238 10.9501 13.507 11.3063 13.5674 11.6554L14.1549 15.0523C14.3069 15.9312 13.3767 16.6015 12.5807 16.1865L9.5045 14.5826C9.18843 14.4179 8.81082 14.4179 8.49475 14.5826L5.41853 16.1865C4.62258 16.6015 3.6923 15.9312 3.84431 15.0523L4.43182 11.6554C4.49218 11.3063 4.3755 10.9501 4.11979 10.703L1.63108 8.29727C0.987132 7.67481 1.34247 6.59028 2.23237 6.46205L5.67169 5.96644C6.02507 5.91552 6.33056 5.69542 6.4886 5.37787L8.0267 2.28723Z"
        fill={color}
      />
    </svg>
  );
};

export const Language = forwardRef<SVGSVGElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#fff';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none" {...attr}>
      <ellipse cx="7.99994" cy="8.00109" rx="5.99067" ry="5.99067" stroke={color} strokeWidth="1.5" />
      <path
        d="M8.27246 1.89062C9.56254 3.58686 10.3284 5.7035 10.3284 7.99902C10.3284 10.2945 9.56254 12.4112 8.27246 14.1074"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M7.72412 1.89062C6.43404 3.58686 5.66823 5.7035 5.66823 7.99902C5.66823 10.2945 6.43404 12.4112 7.72412 14.1074"
        stroke={color}
        strokeWidth="1.5"
      />
      <line x1="2.3623" y1="5.91406" x2="13.7022" y2="5.91406" stroke={color} strokeWidth="1.5" />
      <line x1="2.3623" y1="9.91145" x2="13.7022" y2="9.91145" stroke={color} strokeWidth="1.5" />
    </svg>
  );
});

export const Trash = forwardRef<SVGSVGElement, ISvg>((props, _) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#fff';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...attr}>
      <path
        d="M2.5 5.00002H17.5M15.8333 5.00002L15 16.6667C15 17.5 14.1667 18.3334 13.3333 18.3334H6.66667C5.83333 18.3334 5 17.5 5 16.6667L4.16667 5.00002M6.66667 5.00002V3.33335C6.66667 2.50002 7.5 1.66669 8.33333 1.66669H11.6667C12.5 1.66669 13.3333 2.50002 13.3333 3.33335V5.00002"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export const Filter = forwardRef<SVGSVGElement, ISvg>((props, _) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#fff';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...attr}>
      <path
        d="M13.829 3.25745H2.17896L6.83896 8.7679V12.5774L9.16896 13.7425V8.7679L13.829 3.25745Z"
        stroke={color}
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export const Share = forwardRef<SVGAElement, ISvg & { customColor?: string; opacity?: number }>((props, _) => {
  const { theme = 'light', customColor, opacity, ...attr } = props;
  const color = theme === 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" {...attr}>
      <g clipPath="url(#clip0_3170_83683)">
        <path
          d="M10.6431 2.12588V4.68833C3.86803 4.97663 1.67362 10.9071 1.02042 13.7561C0.912497 14.2268 1.41242 14.4355 1.74885 14.089C4.92668 10.8164 9.11808 10.697 10.6431 10.5213V13.0092C10.6431 13.4561 11.1846 13.6785 11.4987 13.3606L16.6281 8.17032C16.8143 7.9819 16.8213 7.68096 16.6439 7.48416L11.5145 1.79136C11.2079 1.45103 10.6431 1.66778 10.6431 2.12588Z"
          fill={color}
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_3170_83683">
          <rect width="16" height="16" fill="white" transform="translate(0.958984 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
});

export const PShare = forwardRef<SVGAElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme === 'light' ? '#09090B ' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...attr}>
      <g clipPath="url(#clip0_365_11313)">
        <path
          d="M10.9872 1.74241V4.21872C4.78462 4.48266 4.04166 10.9837 4.04199 11.1606C6.31412 8.05768 9.79993 7.55533 10.9872 7.4185V9.79638C10.9872 9.88344 11.0908 9.92892 11.1549 9.87002L15.0451 6.29632C15.2546 6.10388 15.2615 5.77569 15.0604 5.57455L11.158 1.67211C11.095 1.60912 10.9872 1.65332 10.9872 1.74241Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M3.84842 4.32076H2.8457C1.74113 4.32076 0.845703 5.21619 0.845703 6.32076V13.2222C0.845703 14.3268 1.74113 15.2222 2.8457 15.2222H10.4762C11.5807 15.2222 12.4762 14.3268 12.4762 13.2222V12.4655"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_365_11313">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export const Question = forwardRef<SVGAElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...attr}>
      <circle cx="8" cy="8.5" r="7.25" stroke={color} strokeOpacity="0.5" strokeWidth="1.5" />
      <path
        d="M5.50098 6.81134C5.56416 5.98919 6.43856 4.68353 8.11957 4.7796C9.80058 4.87566 10.4482 5.9548 10.4482 6.81134C10.4482 7.34853 10.1802 8.33577 8.71665 9.15978C8.09565 9.50942 7.8666 9.98124 7.88241 10.1156"
        stroke={color}
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="7.89697" cy="12.2099" r="0.75" fill={color} fillOpacity="0.5" />
    </svg>
  );
});

export const User = forwardRef<SVGElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" {...attr}>
      <g clipPath="url(#clip0_388_9605)">
        <path
          d="M11.1228 13.6339C11.1228 12.3531 10.614 11.1248 9.70839 10.2192C8.80276 9.31355 7.57446 8.80477 6.2937 8.80477M6.2937 8.80477C5.01294 8.80477 3.78464 9.31355 2.87901 10.2192C1.97338 11.1248 1.4646 12.3531 1.4646 13.6339M6.2937 8.80477C8.07173 8.80477 9.5131 7.36339 9.5131 5.58537C9.5131 3.80734 8.07173 2.36597 6.2937 2.36597C4.51567 2.36597 3.0743 3.80734 3.0743 5.58537C3.0743 7.36339 4.51567 8.80477 6.2937 8.80477ZM15.934 13.6339C15.934 12.3531 15.4252 11.1248 14.5196 10.2192C13.6139 9.31355 12.1804 8.75334 11.755 8.80477C12.2595 8.74378 12.9912 8.25194 13.3813 7.86183C13.9851 7.25807 14.3243 6.43921 14.3243 5.58537C14.3243 4.73153 13.9851 3.91266 13.3813 3.30891C12.7776 2.70515 11.9587 2.36597 11.1049 2.36597"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_388_9605">
          <rect width="16" height="16" fill="white" transform="translate(0.699463)" />
        </clipPath>
      </defs>
    </svg>
  );
});

export const Edit = forwardRef<SVGAElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...attr}>
      <path
        d="M15.2024 16.4999H0.79794C0.469838 16.4999 0.197754 16.2278 0.197754 15.8997C0.197754 15.5716 0.469838 15.2996 0.79794 15.2996H15.2024C15.5305 15.2996 15.8026 15.5716 15.8026 15.8997C15.8026 16.2278 15.5305 16.4999 15.2024 16.4999Z"
        fill={color}
        fillOpacity="0.8"
      />
      <path
        d="M13.6176 1.67941C12.0652 0.126932 10.5447 0.0869198 8.95219 1.67941L7.98389 2.64771C7.90387 2.72774 7.87186 2.85578 7.90387 2.96781C8.51206 5.08847 10.2086 6.78499 12.3292 7.39318C12.3612 7.40118 12.3933 7.40919 12.4253 7.40919C12.5133 7.40919 12.5933 7.37718 12.6573 7.31316L13.6176 6.34486C14.4099 5.56062 14.794 4.80038 14.794 4.03214C14.802 3.2399 14.4179 2.47166 13.6176 1.67941Z"
        fill={color}
        fillOpacity="0.8"
      />
      <path
        d="M10.8893 8.12144C10.6572 8.00941 10.4332 7.89737 10.2171 7.76933C10.041 7.6653 9.87299 7.55327 9.70494 7.43323C9.5689 7.3452 9.40885 7.21716 9.2568 7.08912C9.24079 7.08112 9.18478 7.0331 9.12076 6.96908C8.85667 6.74502 8.56058 6.45693 8.2965 6.13683C8.27249 6.12082 8.23248 6.0648 8.17646 5.99278C8.09644 5.89675 7.9604 5.7367 7.84036 5.55265C7.74433 5.43261 7.6323 5.25655 7.52826 5.0805C7.40022 4.86443 7.28819 4.64837 7.17615 4.4243C7.15917 4.38791 7.14275 4.35171 7.12681 4.31572C7.00876 4.04906 6.66105 3.9711 6.45484 4.17731L1.87051 8.76164C1.76648 8.86567 1.67045 9.06573 1.64644 9.20178L1.21431 12.2667C1.13428 12.8109 1.28633 13.3231 1.62243 13.6672C1.91052 13.9472 2.31065 14.0993 2.74278 14.0993C2.83881 14.0993 2.93484 14.0913 3.03087 14.0753L6.10382 13.6432C6.24787 13.6191 6.44793 13.5231 6.54396 13.4191L11.1226 8.84047C11.3302 8.63283 11.2519 8.27646 10.9818 8.16122C10.9513 8.14822 10.9205 8.13497 10.8893 8.12144Z"
        fill={color}
        fillOpacity="0.8"
      />
    </svg>
  );
});

export const Like = (props: IHighlight) => {
  const { theme = 'light', highlightColor, ...attr } = props;
  const color = highlightColor || (theme == 'light' ? '#18181B33' : '#FAFAFA33');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" {...attr}>
      <g clipPath="url(#clip0_366_22678)">
        <path
          d="M12.252 1.78564C11.0706 1.78564 9.99703 2.22894 9.10383 3.07704C8.20513 2.21904 7.15023 1.78564 5.95563 1.78564C3.10554 1.78564 0.785645 4.26944 0.785645 7.32193C0.785645 9.10943 1.58314 10.3524 2.16724 11.2643C3.53564 13.417 6.36923 15.6511 7.93563 16.7907L8.00823 16.8435C8.31953 17.0855 8.69573 17.2142 9.09503 17.2142C9.47123 17.2142 9.83863 17.0932 10.1576 16.8622L10.1774 16.8468L10.2533 16.7918C11.8197 15.65 14.6533 13.4126 16.0338 11.261C16.6168 10.3524 17.4132 9.10943 17.4132 7.32193C17.4132 4.26944 15.0977 1.78564 12.252 1.78564Z"
          fill={color}
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_366_22678">
          <rect width="18" height="18" fill="white" transform="translate(0.100098 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

interface IProps extends Omit<ComponentPropsWithoutRef<'img'>, 'src'> {
  status?: SortTypeEnum;
  theme: 'light' | 'dark' | 'system';
}
export const SortIcon = (props: IProps) => {
  const { status = SortTypeEnum.DEFAULT, theme, ...attr } = props;
  const sortDefaultIcon = theme == 'light' ? '/icon/sort-default.png' : '/icon/sort-default-dark.png';
  const sortDescIcon = theme == 'light' ? '/icon/sort-desc.png' : '/icon/sort-desc-dark.png';
  const sortAscIcon = theme == 'light' ? '/icon/sort-asc.png' : '/icon/sort-asc-dark.png';
  const currentIcon = status == SortTypeEnum.DEFAULT ? sortDefaultIcon : status == SortTypeEnum.DESC ? sortDescIcon : sortAscIcon;
  return <img src={currentIcon} {...attr} />;
};

export const Refresh = forwardRef<SVGAElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...attr}>
      <path
        d="M15.75 9C15.75 10.335 15.3541 11.6401 14.6124 12.7501C13.8707 13.8601 12.8165 14.7253 11.5831 15.2362C10.3497 15.7471 8.99252 15.8808 7.68314 15.6203C6.37377 15.3599 5.17104 14.717 4.22703 13.773C3.28303 12.829 2.64015 11.6262 2.3797 10.3169C2.11925 9.00749 2.25292 7.65029 2.76382 6.41689C3.27471 5.18349 4.13987 4.12928 5.2499 3.38758C6.35994 2.64588 7.66498 2.25 9 2.25C10.89 2.25 12.6975 3 14.055 4.305L15.75 6M15.75 6V2.25M15.75 6H12"
        stroke={color}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export const Follow = forwardRef<SVGElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'dark' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...attr}>
      <g clipPath="url(#clip0_459_11085)">
        <path
          d="M6.10693 8.33935C8.08307 8.33935 9.68505 6.73737 9.68505 4.76123C9.68505 2.78509 8.08307 1.18311 6.10693 1.18311C4.13079 1.18311 2.52881 2.78509 2.52881 4.76123C2.52881 6.73737 4.13079 8.33935 6.10693 8.33935Z"
          fill={color}
        />
        <path
          d="M10.6668 8.33936C10.6668 7.94662 10.9852 7.62824 11.3779 7.62824H12.6224V6.38376C12.6224 5.99103 12.9408 5.67266 13.3335 5.67266C13.7262 5.67266 14.0446 5.99103 14.0446 6.38376V7.62824H15.2891C15.6818 7.62824 16.0002 7.94662 16.0002 8.33936C16.0002 8.73209 15.6818 9.05047 15.2891 9.05047H14.0446V10.2949C14.0446 10.6876 13.7262 11.006 13.3335 11.006C12.9408 11.006 12.6224 10.6876 12.6224 10.2949V9.05047H11.3779C10.9852 9.05047 10.6668 8.73209 10.6668 8.33936Z"
          fill={color}
        />
        <path
          d="M6.24463 9.31498C3.1767 9.31498 0.631844 11.5545 0.155672 14.4879C0.0671794 15.0331 0.523399 15.4839 1.07568 15.4839H11.4136C11.9659 15.4839 12.4221 15.0331 12.3336 14.4879C11.8574 11.5545 9.31256 9.31498 6.24463 9.31498Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_459_11085">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export const Wallet = forwardRef<SVGElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none" {...attr}>
      <path
        d="M12.6512 7.08207L12.6512 7.08206L12.6504 7.07325C12.625 6.80654 12.7256 6.55476 12.9077 6.37703L12.9145 6.37038L12.9211 6.36356C13.075 6.20557 13.2887 6.11035 13.5358 6.11035H15.1802C15.2299 6.11527 15.2498 6.15173 15.2498 6.17635V7.82435C15.2498 7.84897 15.2299 7.88544 15.1802 7.89035H13.6318C13.0987 7.89035 12.6861 7.50105 12.6512 7.08207Z"
        fill="#292D32"
        stroke="#FAFAFA"
        strokeWidth="1.5"
      />
      <path
        d="M14.776 9.84019H13.632C12.112 9.84019 10.832 8.69619 10.704 7.2402C10.632 6.4082 10.936 5.57619 11.544 4.98419C12.056 4.45619 12.768 4.16019 13.536 4.16019H14.776C15.008 4.16019 15.2 3.9682 15.176 3.7362C15 1.7922 13.712 0.464195 11.8 0.240195C11.608 0.208195 11.408 0.200195 11.2 0.200195H4C3.776 0.200195 3.56 0.216195 3.352 0.248195C1.312 0.504195 0 2.0242 0 4.2002V9.80019C0 12.0082 1.792 13.8002 4 13.8002H11.2C13.44 13.8002 14.984 12.4002 15.176 10.2642C15.2 10.0322 15.008 9.84019 14.776 9.84019ZM8.8 5.20019H4C3.672 5.20019 3.4 4.92819 3.4 4.60019C3.4 4.27219 3.672 4.0002 4 4.0002H8.8C9.128 4.0002 9.4 4.27219 9.4 4.60019C9.4 4.92819 9.128 5.20019 8.8 5.20019Z"
        fill="#292D32"
      />
    </svg>
  );
});

export const Dollar = forwardRef<SVGElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...attr}>
      <path
        d="M6.49512 1.57691C7.01098 1.44571 7.55138 1.37598 8.10808 1.37598C11.7109 1.37598 14.6316 4.29664 14.6316 7.89946C14.6316 9.65759 13.9361 11.2533 12.8052 12.4264L11.8999 10.7394"
        stroke={color}
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.715 5.53608H6.95912C6.314 5.53608 5.79102 6.05906 5.79102 6.70419V6.70419C5.79102 7.34931 6.314 7.87229 6.95912 7.87229H8.9012C9.56133 7.87229 10.0965 8.40744 10.0965 9.06757V9.06757C10.0965 9.7277 9.56133 10.2628 8.9012 10.2628H6.17229M7.92247 4.34079V5.53606M7.92247 10.2628V11.4581"
        stroke={color}
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.58093 14.4612C9.10552 14.5676 8.61114 14.6237 8.10365 14.6237C4.38321 14.6237 1.36719 11.6077 1.36719 7.88722C1.36719 6.1878 1.99647 4.63536 3.03472 3.4502L4.01122 5.03483"
        stroke={color}
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export const FullFilter = forwardRef<SVGElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...attr}>
      <g clipPath="url(#clip0_720_12158)">
        <path
          d="M14.7477 2.28096C15.2424 1.69598 14.8266 0.799805 14.0605 0.799805H1.93977C1.17367 0.799805 0.757867 1.69598 1.25256 2.28096L6.40011 8.36794V12.982C6.40011 13.3608 6.61411 13.707 6.9529 13.8764L8.87656 14.8383C9.20901 15.0045 9.60017 14.7627 9.60017 14.391V8.36794L14.7477 2.28096Z"
          fill={color}
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_720_12158">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export const SolIcon = forwardRef<SVGElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...attr}>
      <path
        d="M15.7888 11.7414L13.1899 14.5281C13.1337 14.5886 13.0656 14.6369 12.9899 14.67C12.9142 14.703 12.8325 14.7201 12.7499 14.7202H0.429893C0.371133 14.7202 0.313658 14.703 0.264505 14.6708C0.215352 14.6386 0.176655 14.5928 0.153151 14.5389C0.129648 14.4851 0.122359 14.4255 0.132177 14.3676C0.141994 14.3097 0.168493 14.2558 0.208427 14.2127L2.80443 11.4261C2.86064 11.3655 2.92872 11.3173 3.00442 11.2842C3.08013 11.2511 3.16182 11.234 3.24443 11.2339H15.5644C15.6237 11.2327 15.6821 11.2491 15.7321 11.2809C15.7821 11.3128 15.8216 11.3587 15.8456 11.4129C15.8696 11.4672 15.877 11.5273 15.8669 11.5858C15.8568 11.6442 15.8296 11.6984 15.7888 11.7414ZM13.1899 6.12847C13.1335 6.06821 13.0653 6.0201 12.9897 5.98706C12.914 5.95403 12.8324 5.93677 12.7499 5.93633H0.429893C0.371133 5.93637 0.313658 5.95353 0.264505 5.98573C0.215352 6.01793 0.176655 6.06376 0.153151 6.11762C0.129648 6.17147 0.122359 6.23101 0.132177 6.28895C0.141994 6.34688 0.168493 6.4007 0.208427 6.4438L2.80443 9.23193C2.86085 9.29219 2.92897 9.34031 3.00462 9.37335C3.08028 9.40638 3.16188 9.42364 3.24443 9.42407H15.5644C15.6231 9.42375 15.6803 9.40638 15.7293 9.37407C15.7782 9.34176 15.8167 9.29591 15.84 9.24211C15.8633 9.18832 15.8705 9.12889 15.8606 9.07109C15.8507 9.01329 15.8243 8.95961 15.7844 8.9166L13.1899 6.12847ZM0.429893 4.12647H12.7499C12.8325 4.12641 12.9142 4.10931 12.9899 4.07626C13.0656 4.0432 13.1337 3.99488 13.1899 3.93433L15.7888 1.14767C15.8192 1.11545 15.8422 1.07694 15.856 1.03486C15.8698 0.992783 15.8742 0.948174 15.8689 0.904201C15.8635 0.860183 15.8484 0.817907 15.8247 0.780387C15.8011 0.742866 15.7694 0.711026 15.7321 0.687135C15.682 0.655301 15.6237 0.638972 15.5644 0.640201H3.24443C3.16182 0.640288 3.08012 0.657393 3.00442 0.69045C2.92872 0.723506 2.86064 0.771805 2.80443 0.832335L0.208427 3.619C0.168493 3.66211 0.141994 3.71592 0.132177 3.77385C0.122359 3.83179 0.129648 3.89133 0.153151 3.94518C0.176655 3.99904 0.215352 4.04487 0.264505 4.07707C0.313658 4.10927 0.371133 4.12643 0.429893 4.12647Z"
        fill={color}
        fillOpacity="0.8"
      />
    </svg>
  );
});

export const BscIcon = forwardRef<SVGElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" {...attr}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.94689 5.7924L12.3882 3.72305L15.8295 5.7924L17.8356 4.5881L12.3719 1.31445L6.9082 4.5881L8.94689 5.7924ZM17.8519 8.72773L15.8458 7.52344L12.4045 9.59279L8.96322 7.52344L6.95715 8.72773V11.1363L10.3984 13.2057V17.3444L12.4045 18.5487L14.4106 17.3444V13.2057L17.8519 11.1363V8.72773ZM17.8519 12.8652V15.2738L15.8458 16.4781V14.0695L17.8519 12.8652ZM19.2871 16.1399L15.8458 18.2092V20.6178L21.3095 17.3442V10.7969L19.3034 12.0012V16.1399H19.2871ZM19.2871 7.86184L17.2811 6.65754L19.2871 5.45325L21.2932 6.65754V9.06614L19.2871 10.2704V7.86184ZM12.3882 20.2785L10.3821 19.0742V21.4828L12.3882 22.6871L14.3942 21.4828V19.0742L12.3882 20.2785ZM8.94686 16.4781L6.9408 15.2738V12.8652L8.94686 14.0695V16.4781ZM10.3821 6.65754L12.3882 7.86184L14.3942 6.65754L12.3882 5.45325L10.3821 6.65754ZM7.51163 6.65754L5.50555 7.86184V10.2704L3.49951 9.06614V6.65754L5.50555 5.45325L7.51163 6.65754ZM5.50555 12.0012L3.49951 10.7969V17.3442L8.96319 20.6178V18.2092L5.52187 16.1399V12.0012H5.50555Z"
        fill={color}
        fillOpacity="0.8"
      />
    </svg>
  );
});

export const WalletTrade = (props: ISvg) => {
  const { ...attr } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none" {...attr}>
      <path
        d="M15.991 6.35164V7.99964C15.991 8.43964 15.639 8.79964 15.191 8.81564H13.623C12.759 8.81564 11.967 8.18364 11.895 7.31964C11.847 6.81564 12.039 6.34364 12.375 6.01564C12.671 5.71164 13.079 5.53564 13.527 5.53564H15.191C15.639 5.55164 15.991 5.91164 15.991 6.35164Z"
        fill="white"
      />
      <path
        d="M14.7672 10.0155H13.6232C12.1032 10.0155 10.8232 8.87149 10.6952 7.41549C10.6232 6.58349 10.9272 5.75149 11.5352 5.15949C12.0472 4.63149 12.7592 4.33549 13.5272 4.33549H14.7672C14.9992 4.33549 15.1912 4.14349 15.1672 3.91149C14.9912 1.96749 13.7032 0.639488 11.7912 0.415488C11.5992 0.383488 11.3992 0.375488 11.1912 0.375488H3.99121C3.76721 0.375488 3.55121 0.391488 3.34321 0.423488C1.30321 0.679488 -0.00878906 2.19949 -0.00878906 4.37549V9.97549C-0.00878906 12.1835 1.78321 13.9755 3.99121 13.9755H11.1912C13.4312 13.9755 14.9752 12.5755 15.1672 10.4395C15.1912 10.2075 14.9992 10.0155 14.7672 10.0155ZM8.79121 5.37549H3.99121C3.66321 5.37549 3.39121 5.10349 3.39121 4.77549C3.39121 4.44749 3.66321 4.17549 3.99121 4.17549H8.79121C9.11921 4.17549 9.39121 4.44749 9.39121 4.77549C9.39121 5.10349 9.11921 5.37549 8.79121 5.37549Z"
        fill="white"
      />
    </svg>
  );
};

export const Setting = forwardRef<SVGElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" {...attr}>
      <path
        d="M12.636 2H12.196C11.6656 2 11.1569 2.21071 10.7818 2.58579C10.4067 2.96086 10.196 3.46957 10.196 4V4.18C10.1957 4.53073 10.1031 4.87519 9.92756 5.17884C9.75204 5.48248 9.49975 5.73464 9.19602 5.91L8.76602 6.16C8.46198 6.33554 8.11709 6.42795 7.76602 6.42795C7.41494 6.42795 7.07006 6.33554 6.76602 6.16L6.61602 6.08C6.15708 5.81526 5.61185 5.74344 5.10002 5.88031C4.58818 6.01717 4.15157 6.35154 3.88602 6.81L3.66602 7.19C3.40128 7.64893 3.32946 8.19416 3.46633 8.706C3.60319 9.21783 3.93755 9.65445 4.39602 9.92L4.54602 10.02C4.84829 10.1945 5.09964 10.4451 5.27507 10.7468C5.4505 11.0486 5.54391 11.391 5.54602 11.74V12.25C5.54742 12.6024 5.45567 12.949 5.28006 13.2545C5.10445 13.5601 4.85123 13.8138 4.54602 13.99L4.39602 14.08C3.93755 14.3456 3.60319 14.7822 3.46633 15.294C3.32946 15.8058 3.40128 16.3511 3.66602 16.81L3.88602 17.19C4.15157 17.6485 4.58818 17.9828 5.10002 18.1197C5.61185 18.2566 6.15708 18.1847 6.61602 17.92L6.76602 17.84C7.07006 17.6645 7.41494 17.5721 7.76602 17.5721C8.11709 17.5721 8.46198 17.6645 8.76602 17.84L9.19602 18.09C9.49975 18.2654 9.75204 18.5175 9.92756 18.8212C10.1031 19.1248 10.1957 19.4693 10.196 19.82V20C10.196 20.5304 10.4067 21.0391 10.7818 21.4142C11.1569 21.7893 11.6656 22 12.196 22H12.636C13.1665 22 13.6752 21.7893 14.0502 21.4142C14.4253 21.0391 14.636 20.5304 14.636 20V19.82C14.6364 19.4693 14.729 19.1248 14.9045 18.8212C15.08 18.5175 15.3323 18.2654 15.636 18.09L16.066 17.84C16.3701 17.6645 16.7149 17.5721 17.066 17.5721C17.4171 17.5721 17.762 17.6645 18.066 17.84L18.216 17.92C18.675 18.1847 19.2202 18.2566 19.732 18.1197C20.2439 17.9828 20.6805 17.6485 20.946 17.19L21.166 16.8C21.4308 16.3411 21.5026 15.7958 21.3657 15.284C21.2288 14.7722 20.8945 14.3356 20.436 14.07L20.286 13.99C19.9808 13.8138 19.7276 13.5601 19.552 13.2545C19.3764 12.949 19.2846 12.6024 19.286 12.25V11.75C19.2846 11.3976 19.3764 11.051 19.552 10.7455C19.7276 10.4399 19.9808 10.1862 20.286 10.01L20.436 9.92C20.8945 9.65445 21.2288 9.21783 21.3657 8.706C21.5026 8.19416 21.4308 7.64893 21.166 7.19L20.946 6.81C20.6805 6.35154 20.2439 6.01717 19.732 5.88031C19.2202 5.74344 18.675 5.81526 18.216 6.08L18.066 6.16C17.762 6.33554 17.4171 6.42795 17.066 6.42795C16.7149 6.42795 16.3701 6.33554 16.066 6.16L15.636 5.91C15.3323 5.73464 15.08 5.48248 14.9045 5.17884C14.729 4.87519 14.6364 4.53073 14.636 4.18V4C14.636 3.46957 14.4253 2.96086 14.0502 2.58579C13.6752 2.21071 13.1665 2 12.636 2Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.416 15C14.0729 15 15.416 13.6569 15.416 12C15.416 10.3431 14.0729 9 12.416 9C10.7592 9 9.41602 10.3431 9.41602 12C9.41602 13.6569 10.7592 15 12.416 15Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export const Rocket = (props: ISvg) => {
  const { ...attr } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" {...attr}>
      <g clipPath="url(#clip0_871_10054)">
        <path
          d="M16.1732 0.664691C16.1493 0.561963 16.0971 0.467985 16.0225 0.393402C15.9479 0.318819 15.8539 0.266611 15.7512 0.242691C12.6652 -0.466109 9.29881 0.377491 6.90002 2.77589C6.56187 3.11431 6.25003 3.47803 5.96722 3.86389C5.88722 3.97309 5.77242 4.04869 5.64122 4.08109C4.38802 4.39149 3.18122 5.04589 2.17882 6.04829C1.73031 6.49594 1.33979 6.99814 1.01642 7.54309C0.742415 8.00589 1.21202 8.55149 1.71642 8.36509C2.51242 8.07069 3.37242 7.92629 4.25882 7.92589C4.24642 8.00149 4.22882 8.07629 4.21802 8.15189C4.84016 8.87589 5.48915 9.57638 6.16362 10.2519C6.83903 10.9265 7.53952 11.5755 8.26362 12.1975C8.33922 12.1867 8.41402 12.1691 8.48922 12.1567C8.48882 13.0431 8.34402 13.9031 8.05001 14.6991C7.86362 15.2035 8.40922 15.6731 8.87202 15.3991C9.417 15.0756 9.91931 14.6851 10.3672 14.2367C11.326 13.2835 12.0061 12.0863 12.334 10.7747C12.3664 10.6435 12.4424 10.5287 12.5512 10.4487C12.937 10.1658 13.3007 9.85394 13.6392 9.51589C16.0384 7.11669 16.882 3.75069 16.1732 0.664691ZM12.3072 6.82229C12.129 7.00049 11.9175 7.14185 11.6846 7.2383C11.4518 7.33474 11.2022 7.38438 10.9502 7.38438C10.6982 7.38438 10.4486 7.33474 10.2158 7.2383C9.98298 7.14185 9.77142 7.00049 9.59321 6.82229C9.41501 6.64409 9.27365 6.43253 9.17721 6.19969C9.08077 5.96686 9.03113 5.71731 9.03113 5.46529C9.03113 5.21327 9.08077 4.96372 9.17721 4.73089C9.27365 4.49805 9.41501 4.28649 9.59321 4.10829C9.77142 3.93009 9.98298 3.78873 10.2158 3.69229C10.4486 3.59584 10.6982 3.5462 10.9502 3.5462C11.2022 3.5462 11.4518 3.59584 11.6846 3.69229C11.9175 3.78873 12.129 3.93009 12.3072 4.10829C12.4854 4.28649 12.6268 4.49805 12.7232 4.73089C12.8197 4.96372 12.8693 5.21327 12.8693 5.46529C12.8693 5.71731 12.8197 5.96686 12.7232 6.19969C12.6268 6.43253 12.4854 6.64409 12.3072 6.82229Z"
          fill="white"
        />
        <path
          d="M2.88651 10.987C2.30491 11.5686 -0.161086 15.173 0.540914 15.875C1.24291 16.577 4.84731 14.1106 5.42891 13.529C6.01051 12.9474 5.91291 11.907 5.21091 11.205C4.50891 10.503 3.46811 10.4054 2.88651 10.987Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_871_10054">
          <rect width="16" height="16" fill="white" transform="translate(0.416016)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Lightning = (props: ISvg) => {
  const { ...attr } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="15" viewBox="0 0 11 15" fill="none" {...attr}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.55809 0.212957C6.75588 0.297595 6.87019 0.506493 6.83481 0.718712L5.99205 5.7753H10.1079C10.2845 5.7753 10.4462 5.87517 10.5252 6.03327C10.6043 6.19137 10.5872 6.38056 10.4811 6.52197L4.88117 13.9886C4.75209 14.1607 4.52206 14.2222 4.32426 14.1377C4.12646 14.053 4.01215 13.8441 4.04753 13.6319L4.89029 8.57529H0.774525C0.597771 8.57529 0.436183 8.47542 0.35713 8.31732C0.278086 8.15923 0.295138 7.97003 0.401192 7.82862L6.00117 0.361995C6.13026 0.189877 6.36029 0.128318 6.55809 0.212957Z"
        fill="black"
      />
    </svg>
  );
};

export const Notify = forwardRef<SVGAElement, ISvg>((props, _) => {
  const { theme = 'light', ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" {...attr}>
      <path
        d="M13.4757 11.6302L12.2648 9.21143C12.2523 9.18486 12.2445 9.15674 12.2445 9.12705L12.2414 6.44893C12.2398 4.93799 11.2164 3.66611 9.8273 3.28643V3.28486C9.8273 2.41611 9.12262 1.71143 8.25387 1.71143C7.38668 1.71143 6.68355 2.41299 6.68043 3.28018C5.27574 3.65361 4.2398 4.93486 4.24137 6.45674L4.24449 9.13486C4.24449 9.16455 4.23824 9.19268 4.22418 9.21924L3.0148 11.6349C2.66168 12.3411 3.17574 13.1739 3.96637 13.1724L12.5273 13.1661C13.3164 13.1677 13.8304 12.3364 13.4757 11.6302Z"
        fill={color}
        fillOpacity="0.8"
      />
      <path
        d="M6.3615 14.0986C6.24286 13.9498 6.34644 13.7295 6.53664 13.7295H9.94531C10.1355 13.7276 10.2391 13.948 10.1205 14.0967C9.67789 14.6485 8.99992 15.0007 8.23909 15.0007C7.48015 15.0007 6.80218 14.6485 6.3615 14.0986Z"
        fill={color}
        fillOpacity="0.8"
      />
    </svg>
  );
});

interface ISort extends IImg {
  status?: SortTypeEnum;
  theme: 'light' | 'dark' | 'system';
}
export const Sort = (props: ISort) => {
  const { status = '', theme, ...attr } = props;
  const sortDefaultIcon = theme == 'light' ? '/icon/sort-default-light.svg' : '/icon/sort-default-dark.svg';
  const sortDescIcon = theme == 'light' ? '/icon/sort-desc-light.svg' : '/icon/sort-desc-dark.svg';
  const sortAscIcon = theme == 'light' ? '/icon/sort-asc-light.svg' : '/icon/sort-asc-dark.svg';
  const currentIcon = status == SortTypeEnum.DEFAULT ? sortDefaultIcon : status == SortTypeEnum.DESC ? sortDescIcon : sortAscIcon;
  return <img src={currentIcon} {...attr} />;
};

export const Up = (props: ISvg) => {
  const { ...attr } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...attr}>
      <path d="M8.55927 11.8379V5.5994H10.8985L7.00003 0.919434L3.10156 5.5994H5.44079V11.8379H8.56002H8.55927Z" fill="#0ECB81" />
    </svg>
  );
};

export const Down = (props: ISvg) => {
  const { ...attr } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...attr}>
      <path d="M5.43975 2.08598L5.43975 8.32443H3.10052L6.99899 13.0044L10.8975 8.32443H8.55823L8.55823 2.08598H5.439H5.43975Z" fill="#F6465D" />
    </svg>
  );
};

export const Expand = (props: ISvg & { open?: boolean }) => {
  const { theme = 'light', open = false, ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  const opacity = open ? 0.5 : 0.8;
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        opacity={opacity}
        d="M6.00203 5.78531L8.61794 3.22458C8.81087 3.03573 9.11887 3.03413 9.31374 3.22097L11.9862 5.78314C12.1813 5.97022 12.0489 6.29969 11.7785 6.29969H10.0374L10.0374 11.7854L11.7899 11.7854C12.0587 11.7854 12.1918 12.1117 11.9998 12.2998L9.31761 14.9267C9.12177 15.1185 8.80802 15.1169 8.6142 14.9231L5.9887 12.2976C5.79971 12.1086 5.93356 11.7854 6.20083 11.7854H7.88808L7.88808 6.29969H6.21189C5.94307 6.29969 5.80993 5.97335 6.00203 5.78531Z"
        fill={color}
        fillOpacity={opacity}
      />
      <path
        opacity={opacity}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.04492 16.0337C1.04492 15.5159 1.46465 15.0962 1.98242 15.0962L15.9014 15.0962C16.4191 15.0962 16.8389 15.5159 16.8389 16.0337C16.8389 16.5515 16.4191 16.9712 15.9014 16.9712L1.98242 16.9712C1.46465 16.9712 1.04492 16.5515 1.04492 16.0337Z"
        fill={color}
        fillOpacity={opacity}
      />
      <path
        opacity={opacity}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.04492 2.10156C1.04492 1.5838 1.46465 1.16406 1.98242 1.16406L15.9014 1.16406C16.4191 1.16406 16.8389 1.5838 16.8389 2.10156C16.8389 2.61933 16.4191 3.03906 15.9014 3.03906L1.98242 3.03906C1.46465 3.03906 1.04492 2.61933 1.04492 2.10156Z"
        fill={color}
        fillOpacity={opacity}
      />
    </svg>
  );
};

export const Arrow = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" {...attr}>
      <g opacity="0.6">
        <path d="M4.51855 6L8.51855 10L12.5186 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
};

export const Kaleidoscope = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" {...attr}>
      <g clipPath="url(#clip0_1414_18196)">
        <path
          d="M15.5425 6.5504C15.7254 6.01179 15.7888 5.4398 15.7283 4.8742C15.6678 4.30861 15.4848 3.76298 15.1921 3.27526C14.7546 2.5321 14.0945 1.9453 13.3052 1.59788C12.5159 1.25046 11.6373 1.16 10.7938 1.33929C10.4098 0.913908 9.9401 0.57465 9.4156 0.343834C8.89109 0.113017 8.32365 -0.00412578 7.75062 0.000110952C6.88981 -0.00479677 6.04946 0.262371 5.34952 0.763475C4.64959 1.26458 4.12585 1.974 3.85309 2.79046C3.29135 2.90311 2.76001 3.134 2.29436 3.46779C1.82871 3.80157 1.43942 4.23062 1.15233 4.72643C0.26115 6.24 0.464346 8.15037 1.65473 9.44955C1.47157 9.98805 1.40789 10.56 1.46813 11.1256C1.52836 11.6912 1.71106 12.2369 2.00352 12.7247C2.44113 13.4682 3.10149 14.0552 3.89112 14.4026C4.68076 14.75 5.55967 14.8403 6.40344 14.6607C6.78697 15.0866 7.25657 15.4262 7.78118 15.6571C8.30579 15.888 8.87345 16.0048 9.44659 15.9998C10.3082 16.006 11.1495 15.7388 11.8496 15.2365C12.5497 14.7342 13.0724 14.0229 13.3425 13.2047C13.9043 13.092 14.4356 12.8612 14.9013 12.5274C15.3669 12.1936 15.7562 11.7645 16.0433 11.2687C16.9409 9.75515 16.7329 7.84958 15.5425 6.5488V6.5504ZM9.45139 14.9551C8.7426 14.9551 8.05302 14.7103 7.50583 14.2591C7.53143 14.2447 7.57142 14.2255 7.60182 14.2047L10.829 12.3647C10.9104 12.3204 10.9781 12.2546 11.0246 12.1745C11.0712 12.0944 11.0948 12.003 11.093 11.9103V7.41918L12.4561 8.19997C12.4721 8.20477 12.4817 8.21917 12.4817 8.23517V11.9551C12.4817 13.6095 11.1234 14.9503 9.45139 14.9551ZM2.9203 12.2047C2.56466 11.5991 2.4354 10.8871 2.55551 10.1951C2.57951 10.2111 2.61951 10.2351 2.65151 10.2495L5.87865 12.0895C6.04185 12.1855 6.24345 12.1855 6.41144 12.0895L10.3538 9.84474V11.3999C10.3538 11.4159 10.349 11.4303 10.333 11.4399L7.06903 13.2991C6.37172 13.6953 5.54695 13.8026 4.77146 13.5981C3.99597 13.3935 3.33145 12.8933 2.9203 12.2047ZM2.06912 5.24962C2.42271 4.64003 2.9811 4.17444 3.64989 3.93444V7.72798C3.64989 7.91198 3.75069 8.08637 3.91229 8.18077L7.85462 10.4271L6.49144 11.1999C6.48489 11.2042 6.47741 11.2069 6.46962 11.2077C6.46183 11.2085 6.45396 11.2075 6.44664 11.2047L3.1827 9.34555C2.83869 9.15144 2.53667 8.89092 2.29416 8.57913C2.05166 8.26733 1.87351 7.91047 1.77006 7.52926C1.66661 7.14805 1.63992 6.75009 1.69153 6.35848C1.74314 5.96687 1.87203 5.58941 2.07072 5.24802L2.06912 5.24962ZM13.2817 7.82558L9.33939 5.57922L10.7026 4.80003C10.7093 4.79549 10.7171 4.79267 10.7252 4.79183C10.7333 4.791 10.7414 4.79216 10.749 4.79523L14.0129 6.6544C14.3572 6.84799 14.6596 7.10824 14.9022 7.41994C15.1449 7.73164 15.323 8.08856 15.4262 8.46985C15.5294 8.85115 15.5557 9.24918 15.5034 9.64073C15.4511 10.0323 15.3213 10.4095 15.1217 10.7503C14.7635 11.359 14.2046 11.8241 13.5409 12.0655V8.27197C13.5435 8.1806 13.5206 8.09032 13.4749 8.01121C13.4291 7.93209 13.3622 7.86727 13.2817 7.82398V7.82558ZM14.6417 5.80481C14.6145 5.78881 14.5745 5.76481 14.5441 5.75041L11.3154 3.91044C11.2346 3.86398 11.143 3.83952 11.0498 3.83952C10.9566 3.83952 10.865 3.86398 10.7842 3.91044L6.84184 6.15521V4.60003C6.84184 4.58403 6.84664 4.56963 6.86264 4.56003L10.1266 2.69927C10.8244 2.30234 11.6501 2.19529 12.4261 2.40117C13.202 2.60705 13.8661 3.10939 14.2753 3.80005C14.6305 4.40484 14.7617 5.11522 14.6401 5.80481H14.6417ZM6.10265 8.57596L4.73947 7.80158C4.73215 7.79899 4.72578 7.79424 4.7212 7.78796C4.71663 7.78167 4.71408 7.77415 4.71387 7.76638V4.04484C4.71387 2.39047 6.07705 1.04489 7.75382 1.04969C8.46207 1.04853 9.14849 1.29469 9.69459 1.74568C9.66899 1.76008 9.62899 1.78088 9.59859 1.80008L6.36985 3.64005C6.28824 3.68397 6.22047 3.74974 6.17413 3.82999C6.12779 3.91024 6.1047 4.00181 6.10745 4.09444L6.10265 8.57436V8.57596ZM6.84184 7.00159L8.59861 6.00001L10.357 6.99999V8.99996L8.60341 9.99994L6.84504 8.99996L6.84024 6.99999L6.84184 7.00159Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1414_18196">
          <rect width="16" height="16" fill="white" transform="translate(0.597656)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GraySol = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...attr}>
      <g clipPath="url(#clip0_1428_9662)">
        <path
          d="M11.0187 8.4941L9.2861 10.3519C9.24863 10.3922 9.20324 10.4244 9.15278 10.4465C9.10231 10.4685 9.04784 10.4799 8.99277 10.48H0.779434C0.740261 10.4799 0.701944 10.4685 0.669175 10.447C0.636406 10.4256 0.610608 10.395 0.594939 10.3591C0.579271 10.3232 0.574411 10.2835 0.580956 10.2449C0.587501 10.2063 0.605167 10.1704 0.63179 10.1417L2.36246 8.28388C2.39993 8.24353 2.44532 8.21134 2.49579 8.1893C2.54626 8.16726 2.60072 8.15586 2.65579 8.15579H10.8691C10.9087 8.15498 10.9475 8.16587 10.9809 8.18711C11.0143 8.20834 11.0406 8.23897 11.0566 8.27513C11.0726 8.31129 11.0775 8.35138 11.0708 8.39034C11.064 8.42931 11.0459 8.46541 11.0187 8.4941ZM9.2861 4.75215C9.24848 4.71198 9.20307 4.6799 9.15263 4.65788C9.1022 4.63586 9.0478 4.62435 8.99277 4.62406H0.779434C0.740261 4.62408 0.701944 4.63553 0.669175 4.65699C0.636406 4.67846 0.610608 4.70901 0.594939 4.74492C0.579271 4.78082 0.574411 4.82051 0.580956 4.85914C0.587501 4.89776 0.605167 4.93363 0.63179 4.96237L2.36246 6.82113C2.40007 6.8613 2.44549 6.89338 2.49592 6.9154C2.54636 6.93743 2.60076 6.94893 2.65579 6.94922H10.8691C10.9082 6.949 10.9464 6.93742 10.979 6.91588C11.0116 6.89434 11.0373 6.86378 11.0528 6.82791C11.0684 6.79205 11.0732 6.75243 11.0666 6.7139C11.06 6.67537 11.0424 6.63958 11.0158 6.6109L9.2861 4.75215ZM0.779434 3.41748H8.99277C9.04784 3.41744 9.10231 3.40605 9.15278 3.38401C9.20325 3.36197 9.24864 3.32976 9.2861 3.28939L11.0187 1.43162C11.039 1.41014 11.0543 1.38446 11.0635 1.35641C11.0727 1.32836 11.0757 1.29862 11.0721 1.2693C11.0685 1.23996 11.0584 1.21178 11.0427 1.18676C11.0269 1.16175 11.0058 1.14052 10.9809 1.12459C10.9475 1.10337 10.9086 1.09249 10.8691 1.0933H2.65579C2.60072 1.09336 2.54625 1.10477 2.49578 1.1268C2.44532 1.14884 2.39993 1.18104 2.36246 1.22139L0.63179 3.07917C0.605167 3.10791 0.587501 3.14378 0.580956 3.18241C0.574411 3.22103 0.579271 3.26072 0.594939 3.29663C0.610608 3.33253 0.636406 3.36308 0.669175 3.38455C0.701944 3.40602 0.740261 3.41746 0.779434 3.41748Z"
          fill={color}
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1428_9662">
          <rect width="10.6667" height="10.6667" fill="white" transform="translate(0.492188 0.666626)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const More = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...attr}>
      <path
        d="M10.8333 14.1663L15 9.99967L10.8333 5.83301M5 14.1663L9.16667 9.99967L5 5.83301"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Trans = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" {...attr}>
      <path
        d="M14.1161 7.33347C14.2998 7.33349 14.4771 7.39344 14.6144 7.50195C14.7517 7.61045 14.8394 7.75997 14.8609 7.92214L14.8661 8.00014V10.0001C14.8661 10.5103 14.6469 11.0011 14.2531 11.3723C13.8594 11.7435 13.321 11.9669 12.7481 11.9968L12.6161 12.0001H4.33034L5.42384 12.8255C5.5699 12.9351 5.66337 13.0901 5.68518 13.2589C5.70698 13.4276 5.65547 13.5975 5.54115 13.7336C5.42684 13.8698 5.25836 13.962 5.07012 13.9915C4.88189 14.0209 4.6881 13.9854 4.52834 13.8921L4.45334 13.8415L1.66709 11.7395L1.62509 11.7055L1.56959 11.6508L1.58159 11.6641C1.55615 11.6376 1.53308 11.6092 1.51259 11.5795L1.47209 11.5128L1.44059 11.4421L1.41884 11.3708L1.40534 11.2895L1.40234 11.2321L1.40759 11.1521L1.42409 11.0721L1.44734 11.0028L1.47509 10.9441L1.51184 10.8841L1.54484 10.8401L1.59734 10.7821L1.66559 10.7241L4.44584 8.61747C4.59104 8.50795 4.77766 8.45163 4.96785 8.45992C5.15805 8.46821 5.33757 8.5405 5.47001 8.66213C5.60245 8.78375 5.67788 8.9456 5.68101 9.11484C5.68413 9.28409 5.61472 9.44805 5.48684 9.57347L5.41934 9.63147L4.05284 10.6668H12.6161C12.7998 10.6668 12.9771 10.6068 13.1144 10.4983C13.2517 10.3898 13.3394 10.2403 13.3609 10.0781L13.3661 10.0001V8.00014C13.3661 7.82333 13.4451 7.65376 13.5858 7.52873C13.7264 7.40371 13.9172 7.33347 14.1161 7.33347ZM14.8549 4.4468L14.8399 4.50947L14.8106 4.5848L14.7881 4.63147L14.7416 4.70147L14.6824 4.7708L14.6539 4.7988L14.6456 4.80414L14.6396 4.8108L14.6081 4.83747L11.7619 6.8548C11.6128 6.96124 11.4235 7.01302 11.2329 6.99958C11.0423 6.98613 10.8646 6.90846 10.7363 6.78245C10.6079 6.65644 10.5386 6.49161 10.5424 6.32166C10.5462 6.15171 10.6229 5.98948 10.7569 5.86814L10.8266 5.81214L11.9711 5.00014H3.65234C3.46864 5.00016 3.29134 5.06011 3.15406 5.16861C3.01679 5.27712 2.92909 5.42664 2.90759 5.5888L2.90234 5.6668V7.6668C2.90213 7.83672 2.82893 8.00016 2.69771 8.12372C2.56648 8.24727 2.38713 8.32163 2.1963 8.33158C2.00547 8.34154 1.81756 8.28635 1.67097 8.17729C1.52438 8.06823 1.43017 7.91353 1.40759 7.7448L1.40234 7.6668V5.6668C1.40231 5.15666 1.62159 4.66579 2.01531 4.29463C2.40903 3.92347 2.94742 3.70007 3.52034 3.67014L3.65234 3.6668H11.9726L10.8266 2.8548C10.677 2.74922 10.5784 2.59688 10.5508 2.42886C10.5232 2.26083 10.5688 2.0898 10.6783 1.95064C10.7878 1.81149 10.9529 1.71471 11.1399 1.68005C11.3269 1.64539 11.5217 1.67547 11.6846 1.76414L11.7619 1.81214L14.6081 3.83014L14.6359 3.8528L14.7026 3.91814L14.7334 3.9548L14.7836 4.02947L14.8106 4.08214L14.8391 4.15747L14.8541 4.21614C14.8601 4.2428 14.8631 4.2708 14.8654 4.29814V4.3688C14.8631 4.39547 14.8601 4.4208 14.8549 4.4468Z"
        fill={color}
        fillOpacity="0.8"
      />
      <path
        d="M5.05502 13.895C4.88934 13.9209 4.71949 13.8898 4.58026 13.8094L4.51012 13.762L1.72724 11.6625L1.69024 11.6326L1.63812 11.5812L1.63802 11.5813C1.62229 11.5637 1.60778 11.5453 1.59456 11.5263L1.55877 11.4674L1.53225 11.4079L1.51413 11.3485L1.50258 11.2789L1.50017 11.2328L1.5046 11.1653L1.51855 11.0976L1.53809 11.0393L1.56112 10.9907L1.59272 10.9391L1.62026 10.9023L1.66546 10.8524L1.72676 10.8003L4.50465 8.69543C4.5047 8.6954 4.50475 8.69536 4.5048 8.69532C4.63097 8.60021 4.79498 8.55013 4.9636 8.55748C5.13228 8.56484 5.28951 8.62895 5.40396 8.73406C5.51809 8.83887 5.58077 8.97592 5.58337 9.11665C5.58595 9.25639 5.52918 9.39405 5.42067 9.50158L5.35797 9.55545L3.99387 10.589L3.76224 10.7645H4.05284H12.6161C12.8206 10.7644 13.0195 10.6978 13.1749 10.5749C13.3306 10.4519 13.4326 10.2802 13.4577 10.091L13.4579 10.091L13.4583 10.0847L13.4635 10.0067L13.4638 10.0067V10.0001V8.00014C13.4638 7.85319 13.5293 7.70956 13.6507 7.60172C13.7723 7.49355 13.9396 7.43113 14.1161 7.43113C14.279 7.43115 14.4347 7.48439 14.5538 7.57856C14.6718 7.67184 14.745 7.79796 14.7636 7.93198L14.7684 8.00342V10.0001C14.7685 10.4816 14.5616 10.9473 14.1862 11.3013C13.8106 11.6553 13.2951 11.8702 12.7443 11.8992L12.6149 11.9025H4.33034H4.03885L4.27151 12.0781L5.36501 12.9034L5.36523 12.9036C5.49192 12.9986 5.57016 13.1308 5.58833 13.2714C5.60646 13.4117 5.564 13.5545 5.46636 13.6708C5.36836 13.7876 5.22176 13.8689 5.05502 13.895ZM2.80469 5.6668L2.80469 7.66668C2.80469 7.66671 2.80469 7.66674 2.80469 7.66677C2.80449 7.80801 2.74373 7.94625 2.63076 8.05262C2.51744 8.15932 2.36045 8.22523 2.19121 8.23406C2.02196 8.24289 1.85671 8.19377 1.72926 8.09894C1.603 8.005 1.52434 7.87434 1.5048 7.73489L1.5 7.66352V5.6668C1.49997 5.18533 1.70682 4.71965 2.08229 4.36569C2.45781 4.01169 2.97331 3.7968 3.52414 3.76773L3.65357 3.76446H11.9726H12.2793L12.0291 3.58712L10.8831 2.77512L10.8829 2.77502C10.7529 2.68327 10.6701 2.55316 10.6472 2.41305C10.6242 2.27325 10.6618 2.12963 10.7551 2.01102C10.8487 1.89197 10.9921 1.80676 11.1577 1.77607C11.3223 1.74556 11.4933 1.77195 11.6355 1.84862L11.7078 1.89352L14.5489 3.90787L14.5707 3.92566L14.6309 3.98457L14.6552 4.0136L14.6993 4.07918L14.7212 4.12182L14.7458 4.18694L14.7591 4.23883C14.7632 4.25733 14.7656 4.27816 14.7677 4.30222V4.3646C14.7657 4.38691 14.7633 4.40654 14.7595 4.42584L14.7464 4.4803L14.721 4.54586L14.7031 4.58302L14.6635 4.64252L14.6109 4.70413L14.5925 4.72218L14.5817 4.72917L14.573 4.73881L14.5715 4.74055L14.5482 4.76022L11.7054 6.77513L11.7051 6.77532C11.5753 6.86796 11.4088 6.91409 11.2398 6.90216C11.0707 6.89024 10.9154 6.82144 10.8047 6.71276C10.6943 6.60442 10.6368 6.46513 10.64 6.32386C10.6432 6.18339 10.7062 6.04677 10.8204 5.94239L10.8855 5.8901L12.0276 5.07978L12.2775 4.90248H11.9711H3.65234H3.65233C3.44784 4.90251 3.24893 4.96916 3.09351 5.092C2.93785 5.21504 2.83586 5.38677 2.81078 5.57597L2.81058 5.57595L2.81016 5.58225L2.80491 5.66025L2.80469 5.66023V5.6668Z"
        stroke={color}
        strokeOpacity="0.5"
        strokeWidth="0.195312"
      />
    </svg>
  );
};

export const Link = (props: ISvg & { customColor?: string }) => {
  const { theme, customColor, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none" {...attr}>
      <g clipPath="url(#clip0_1459_36423)">
        <path
          d="M5.75293 6.22396L10.7477 1.39697M10.7477 1.39697H7.32101M10.7477 1.39697V4.54626"
          stroke={customColor || color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.91473 2.05225H2.78993C1.93082 2.05225 1.23438 2.74869 1.23438 3.6078V9.52731C1.23438 10.3864 1.93082 11.0829 2.78993 11.0829H8.61502C9.47413 11.0829 10.1706 10.3864 10.1706 9.52731L10.1706 7.15744"
          stroke={customColor || color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1459_36423">
          <rect width="12" height="12" fill="white" transform="translate(0 0.174805)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Back = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" {...attr}>
      <path
        d="M3 19.5981V5.59814M13 6.59814L7 12.5981M7 12.5981L13 18.5981M7 12.5981H21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MoreDot = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" {...attr}>
      <path
        d="M9.29102 12.5983C9.29102 13.317 9.5765 14.0062 10.0847 14.5144C10.5928 15.0225 11.282 15.308 12.0007 15.308C12.7193 15.308 13.4086 15.0225 13.9167 14.5144C14.4249 14.0062 14.7104 13.317 14.7104 12.5983C14.7104 12.2425 14.6403 11.8902 14.5041 11.5614C14.3679 11.2326 14.1683 10.9339 13.9167 10.6823C13.6651 10.4307 13.3664 10.2311 13.0376 10.0949C12.7089 9.95876 12.3565 9.88867 12.0007 9.88867C11.6449 9.88867 11.2925 9.95876 10.9637 10.0949C10.635 10.2311 10.3363 10.4307 10.0847 10.6823C9.83305 10.9339 9.63345 11.2326 9.49728 11.5614C9.3611 11.8902 9.29102 12.2425 9.29102 12.5983Z"
        fill={color}
      />
      <path
        d="M18.1934 12.5981C18.1933 12.8269 18.2384 13.0534 18.3259 13.2648C18.4134 13.4761 18.5417 13.6682 18.7035 13.83C18.8652 13.9917 19.0573 14.1201 19.2686 14.2076C19.48 14.2952 19.7065 14.3402 19.9353 14.3402C20.1641 14.3402 20.3906 14.2952 20.602 14.2076C20.8133 14.1201 21.0053 13.9917 21.1671 13.83C21.3289 13.6682 21.4572 13.4761 21.5447 13.2648C21.6322 13.0534 21.6773 12.8269 21.6772 12.5981C21.6773 12.3693 21.6322 12.1428 21.5447 11.9314C21.4572 11.7201 21.3289 11.528 21.1671 11.3662C21.0053 11.2045 20.8133 11.0761 20.602 10.9886C20.3906 10.901 20.1641 10.856 19.9353 10.856C19.7065 10.856 19.48 10.901 19.2686 10.9886C19.0573 11.0761 18.8652 11.2045 18.7035 11.3662C18.5417 11.528 18.4134 11.7201 18.3259 11.9314C18.2384 12.1428 18.1933 12.3693 18.1934 12.5981Z"
        fill={color}
      />
      <path
        d="M2.32227 12.5981C2.32224 12.8269 2.36728 13.0534 2.4548 13.2648C2.54233 13.4761 2.67064 13.6682 2.8324 13.83C2.99415 13.9917 3.18619 14.1201 3.39754 14.2076C3.6089 14.2952 3.83543 14.3402 4.0642 14.3402C4.29297 14.3402 4.5195 14.2952 4.73086 14.2076C4.94221 14.1201 5.13425 13.9917 5.29601 13.83C5.45776 13.6682 5.58607 13.4761 5.6736 13.2648C5.76113 13.0534 5.80616 12.8269 5.80614 12.5981C5.80616 12.3693 5.76113 12.1428 5.6736 11.9314C5.58607 11.7201 5.45776 11.528 5.29601 11.3662C5.13425 11.2045 4.94221 11.0761 4.73086 10.9886C4.5195 10.901 4.29297 10.856 4.0642 10.856C3.83543 10.856 3.6089 10.901 3.39754 10.9886C3.18619 11.0761 2.99415 11.2045 2.8324 11.3662C2.67064 11.528 2.54233 11.7201 2.4548 11.9314C2.36728 12.1428 2.32224 12.3693 2.32227 12.5981Z"
        fill={color}
      />
    </svg>
  );
};

export const Pro = (props: IImg) => {
  const { theme, ...attr } = props;
  return theme == 'light' ? <img src="/icon/pro-light.svg" {...attr} /> : <img src="/icon/pro-dark.svg" {...attr} />;
};

export const Transform = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" {...attr}>
      <path
        d="M5.95866 2.24561L3.29199 4.91227M3.29199 4.91227L5.95866 7.57894M3.29199 4.91227H13.9587M11.292 14.2456L13.9587 11.5789M13.9587 11.5789L11.292 8.91227M13.9587 11.5789H3.29199"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WatchStar = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" {...attr}>
      <g clipPath="url(#clip0_1988_491)">
        <path
          d="M10.301 4.76765L10.301 4.7677C10.5672 5.30258 11.0801 5.67039 11.6699 5.75537C11.6699 5.75537 11.6699 5.75537 11.6699 5.75538L15.0563 6.24337L15.0563 6.24338C15.3244 6.282 15.4134 6.59546 15.2341 6.76882L15.2341 6.76883L12.7838 9.13749C12.3542 9.55256 12.1566 10.1528 12.2586 10.7424C12.2586 10.7424 12.2586 10.7424 12.2586 10.7424L12.8371 14.0872L12.8371 14.0872C12.8785 14.3265 12.6189 14.5393 12.3728 14.4111C12.3728 14.4111 12.3728 14.411 12.3728 14.411L9.34388 12.8318L9.34383 12.8318C8.81536 12.5563 8.18469 12.5563 7.65623 12.8318L7.65618 12.8318L4.62723 14.411C4.62723 14.411 4.62722 14.4111 4.62722 14.4111C4.38126 14.5393 4.12154 14.3265 4.16294 14.0872L4.74142 10.7424L4.74142 10.7424C4.84336 10.1529 4.64596 9.55275 4.21642 9.13764C4.21639 9.1376 4.21635 9.13756 4.21631 9.13753L1.76595 6.76882L1.76594 6.76881C1.58664 6.59549 1.67567 6.282 1.9437 6.24337L1.94371 6.24337L5.33018 5.75537C5.33019 5.75537 5.33019 5.75537 5.33019 5.75537C5.91999 5.67039 6.43282 5.30255 6.69902 4.76768L6.69902 4.76766L8.21349 1.72451C8.21349 1.72451 8.21349 1.72451 8.21349 1.72451C8.32943 1.49156 8.67063 1.49158 8.78655 1.7245C8.78655 1.7245 8.78655 1.7245 8.78655 1.7245L10.301 4.76765Z"
          stroke={color}
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_1988_491">
          <rect width="16" height="16" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Setting2 = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" {...attr}>
      <g clipPath="url(#clip0_2007_43642)">
        <path
          d="M2.23074 9.8751C1.7395 9.02424 1.7395 7.97595 2.23074 7.1251L4.40211 3.36418C4.89335 2.51333 5.8012 1.98918 6.78368 1.98918L11.1264 1.98918C12.1089 1.98918 13.0167 2.51333 13.508 3.36418L15.6793 7.1251C16.1706 7.97595 16.1706 9.02424 15.6793 9.8751L13.508 13.636C13.0167 14.4869 12.1089 15.011 11.1264 15.011L6.78368 15.011C5.8012 15.011 4.89335 14.4869 4.40211 13.636L2.23074 9.8751Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M11.4544 8.49961C11.4544 9.88011 10.3353 10.9992 8.95481 10.9992C7.57431 10.9992 6.4552 9.88011 6.4552 8.49961C6.4552 7.11911 7.57431 6 8.95481 6C10.3353 6 11.4544 7.11911 11.4544 8.49961Z"
          stroke={color}
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_2007_43642">
          <rect width="16" height="16" fill="white" transform="translate(0.954834 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Deposit = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none" {...attr}>
      <path
        d="M7.18079 9.75012C7.18079 10.4528 7.72407 11.0178 8.39049 11.0178H9.75229C10.3318 11.0178 10.8026 10.5252 10.8026 9.90948C10.8026 9.2503 10.5129 9.01126 10.0855 8.85915L7.90515 8.09856C7.47778 7.94644 7.18804 7.71464 7.18804 7.04822C7.18804 6.43976 7.65886 5.93994 8.23836 5.93994H9.60018C10.2666 5.93994 10.8099 6.50495 10.8099 7.20759"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.99121 4.40283L8.99121 5.93975" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.99121 11.0176L8.99121 12.3275" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M16.375 8.5C16.375 12.571 13.071 15.875 9 15.875C4.929 15.875 1.625 12.571 1.625 8.5C1.625 4.429 4.929 1.125 9 1.125"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.6875 1.8623V4.8123H15.6375" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.375 1.125L12.6875 4.8125" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const Withdraw = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...attr}>
      <path
        d="M6.20703 9.72851C6.20703 10.4192 6.74111 10.9747 7.39623 10.9747H8.73495C9.30462 10.9747 9.76749 10.4904 9.76749 9.88517C9.76749 9.23716 9.48266 9.00218 9.06252 8.85264L6.91912 8.10494C6.49899 7.9554 6.21416 7.72753 6.21416 7.07241C6.21416 6.47425 6.67701 5.98291 7.24668 5.98291H8.58541C9.24054 5.98291 9.77462 6.53834 9.77462 7.22907"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.98828 4.47217L7.98828 5.98304" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.98828 10.9746L7.98828 12.2624" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15.25 8.5C15.25 12.502 12.002 15.75 8 15.75C3.998 15.75 0.75 12.502 0.75 8.5C0.75 4.498 3.998 1.25 8 1.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.25 4.14999V1.24999M15.25 1.24999H12.35M15.25 1.24999L11.625 4.875"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Disconnect = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...attr}>
      <g clipPath="url(#clip0_3151_50798)">
        <path
          d="M6.91287 15.6563C6.53134 15.6563 5.17669 15.6563 3.84377 15.6563C2.18691 15.6563 0.84375 14.3131 0.84375 12.6563V4.34376C0.84375 2.68691 2.18689 1.34377 3.84374 1.34376C5.17667 1.34376 6.53134 1.34375 6.91287 1.34375M11.1806 12.4757L15.1562 8.5M15.1562 8.5L11.1806 4.52431M15.1562 8.5H5.61458"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3151_50798">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Delegate = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...attr}>
      <path
        d="M8.04829 7.883C8.98968 7.883 9.75282 7.11986 9.75282 6.17848C9.75282 5.23709 8.98968 4.47395 8.04829 4.47395C7.10691 4.47395 6.34376 5.23709 6.34376 6.17848C6.34376 7.11986 7.10691 7.883 8.04829 7.883ZM8.04829 7.883L8.04835 10.1578M8.04835 10.1578V11.9563M8.04835 10.1578H10.0921M1.45142 9.5773L1.45142 3.06535C1.45142 2.50136 1.91745 2.05188 2.48115 2.06998C4.1231 2.1227 5.78288 2.11514 7.56766 1.38659C7.8454 1.27322 8.15736 1.27431 8.43463 1.38883C10.1973 2.11691 11.8613 2.12322 13.521 2.06989C14.0847 2.05177 14.5508 2.50136 14.5508 3.06536V9.5773C14.5508 12.7761 11.5405 14.5157 8.63831 15.5801C8.22685 15.7311 7.7754 15.7311 7.36393 15.5802C4.46176 14.5158 1.45142 12.776 1.45142 9.5773Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ILightning = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#F4F4F5' : '#27272A';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="179" height="316" viewBox="0 0 179 316" fill="none" {...attr}>
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.4181 6.40239L-89.2312 209.925C-100.413 223.917 -86.423 247.289 -68.6747 244.267L-8.7313 234.059L-19.5654 379.635C-21.0458 399.525 3.26638 412.454 14.8438 397.933L174.726 197.419C185.886 183.422 171.9 160.075 154.162 163.091L93.9022 173.338L107.783 25.1057C109.656 5.10658 85.124 -8.24503 73.4181 6.40239Z"
        fill={color}
      />
    </svg>
  );
};

export const KlineIcon = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#09090B' : '#fff';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" {...attr}>
      <g clipPath="url(#clip0_4906_148754)">
        <path
          d="M4.39798 1.94531V4.29277M4.39798 13.6826V17.2038M2.38955 4.29277H6.4114C7.05963 4.29277 7.58513 4.81826 7.58513 5.4665V12.5089C7.58513 13.1571 7.05963 13.6826 6.4114 13.6826H2.38955C1.74132 13.6826 1.21582 13.1571 1.21582 12.5089V5.4665C1.21582 4.81826 1.74132 4.29277 2.38955 4.29277Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.408 3.21874V6.64574M14.408 14.8258V17.5677M12.3996 6.64574H16.4214C17.0696 6.64574 17.5951 7.17124 17.5951 7.81947V13.6521C17.5951 14.3003 17.0696 14.8258 16.4214 14.8258H12.3996C11.7513 14.8258 11.2258 14.3003 11.2258 13.6521L11.2258 7.81947C11.2258 7.17124 11.7513 6.64574 12.3996 6.64574Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4906_148754">
          <rect width="18" height="18" fill="white" transform="translate(0.46582 0.574219)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowDown = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" {...attr}>
      <path
        d="M12.1858 14.7112L8.5562 10.655C8.32563 10.3973 8.50852 9.98828 8.85428 9.98828H16.1008C16.4463 9.98828 16.6293 10.3967 16.3994 10.6545L12.7824 14.7107C12.6235 14.8889 12.345 14.8891 12.1858 14.7112Z"
        fill={color}
      />
    </svg>
  );
};

export interface IChg extends Omit<ComponentPropsWithoutRef<'svg'>, 'type' | 'lightingColor'> {
  children?: JSX.Element | JSX.Element[] | string;
  state: 'up' | 'down';
}
export const Chg = (props: IChg) => {
  const { state, ...attr } = props;
  const color = state == 'up' ? '#0ECB81' : '#F6465D';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" {...attr}>
      <path
        d="M12.1858 14.7112L8.5562 10.655C8.32563 10.3973 8.50852 9.98828 8.85428 9.98828H16.1008C16.4463 9.98828 16.6293 10.3967 16.3994 10.6545L12.7824 14.7107C12.6235 14.8889 12.345 14.8891 12.1858 14.7112Z"
        fill={color}
      />
    </svg>
  );
};

export const Reload = (props: ISvg) => {
  const { theme, ...attr } = props;
  const color = theme == 'light' ? '#18181B' : '#FAFAFA';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none" {...attr}>
      <path
        d="M15.75 9.44629C15.75 10.7813 15.3541 12.0864 14.6124 13.1964C13.8707 14.3064 12.8165 15.1716 11.5831 15.6825C10.3497 16.1934 8.99252 16.327 7.68314 16.0666C6.37377 15.8061 5.17104 15.1633 4.22703 14.2193C3.28303 13.2753 2.64015 12.0725 2.3797 10.7631C2.11925 9.45378 2.25292 8.09658 2.76382 6.86318C3.27471 5.62977 4.13987 4.57557 5.2499 3.83387C6.35994 3.09217 7.66498 2.69629 9 2.69629C10.89 2.69629 12.6975 3.44629 14.055 4.75129L15.75 6.44629M15.75 6.44629V2.69629M15.75 6.44629H12"
        stroke={color}
        strokeWidth="1.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SignalTag = (props: Omit<ComponentPropsWithoutRef<'svg'>, 'type'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19" fill="none" {...props}>
      <path
        d="M0.5 5.42997C0.5 2.58964 2.80254 0.287109 5.64286 0.287109H18.0915C20.3111 0.287109 21.9457 2.36398 21.4241 4.52138L18.7301 15.6642C18.3581 17.2031 16.9808 18.2871 15.3976 18.2871H3.92857C2.03502 18.2871 0.5 16.7521 0.5 14.8585V5.42997Z"
        fill="url(#paint0_linear_5783_159580)"
      />
      <defs>
        <linearGradient id="paint0_linear_5783_159580" x1="6.61049" y1="3.51947" x2="17.8961" y2="17.1121" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE786" />
          <stop offset="1" stopColor="#F0B90B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CheckSuccess = (props: ComponentPropsWithRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...props}>
      <circle cx="8" cy="8.5" r="7.25" stroke="#0ECB81" strokeWidth="1.5" />
      <path d="M4.75293 9.2693L6.74951 11.1456L11.2478 5.85352" stroke="#0ECB81" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const CheckError = (props: ComponentPropsWithRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...props}>
      <circle cx="8" cy="8.5" r="7.25" stroke="#F6465D" strokeWidth="1.5" />
      <path d="M5.49707 6.05078L10.4904 11.0163" stroke="#F6465D" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5.49707 11.0176L10.4904 6.05205" stroke="#F6465D" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

interface IFilterStateIcon extends ISvg {
  apply?: boolean;
}

export const FilterStateIcon = (props: IFilterStateIcon) => {
  const { theme = 'light', apply = false, className, ...attr } = props;
  const strokeColor = theme === 'light' ? '#09090B' : '#FAFAFA';
  const fillColor = theme === 'light' ? '#18181B' : '#FAFAFA';

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" className={className} {...attr}>
      <path
        d="M15.553 3.10156H2.44678L7.68928 9.30082V13.5866L10.3105 14.8972V9.30082L15.553 3.10156Z"
        stroke={strokeColor}
        fill={apply ? fillColor : 'none'}
        strokeWidth={apply ? '1.6875' : '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
